export enum PrintObject {
    TriptikReceipt = -1,
    IntLicenseCommitment = 0,
    IntLicenseCard = 1,
    IntLicenseSticker = 2,
    TripTikFrontCover = 3,
    TripTikInnerPages = 4,
    TripTikBackCover = 5
}